module.exports = __webpack_public_path__ + "static/media/top-bar-backing.6b0cfdd7.png";